{{ initials }}
<ng-content *ngIf="!icon"></ng-content>
<span *ngIf="icon" [class]="icon" [class.avatar-icon]="true"></span>
